angular.module('manageSysManagesyStemPersonalCenterConfigModule', ['personalCenterConfigServiceModule'])
    .controller('manageSysManagesyStemPersonalCenterConfigCtrl', ['$q', '$scope', 'modalDialog', 'trsspliceString', 'trsHttpService', 'personalCenterConfigService',
        function($q, $scope, modalDialog, trsspliceString, trsHttpService, personalCenterConfigService) {
            initStatus();
            requestData();

            function initStatus() {
                $scope.status = {
                    batchOperateBtn: {
                        "hoverStatus": ""
                    }
                };
                $scope.data = {
                    selectedArray: [],
                    items: [],
                    copyCurrPage: 1,
                };
                $scope.page = {
                    "CURRPAGE": 1,
                    "PAGESIZE": 20,
                    "ITEMCOUNT": 0,
                };
            }

            //下一页
            $scope.pageChanged = function() {
                $scope.data.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            //跳转指定页面
            $scope.jumpToPage = function() {
                if ($scope.data.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.data.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.data.copyCurrPage;
                requestData();
            };
            /**
             * [selectPageNum description]单页选择分页数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                $scope.data.copyCurrPage = 1;
                requestData();
            };

            /**
             * [requestData description:数据请求方法：获取列表信息]
             */
            function requestData() {
                var defer = $q.defer();
                var params = {
                    serviceid: "mlf_personalcenter",
                    methodname: "query",
                    CURRPAGE: $scope.page.CURRPAGE,
                    PAGESIZE: $scope.page.PAGESIZE,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    $scope.data.items = data.DATA;
                    $scope.page = data.PAGER;
                    $scope.data.selectedArray = [];
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [selectAll description:全选]
             */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
                cancelBatchOperate();
            };
            /**
             * [selectDoc 单选]
             * @param  {[type]} item [description：单个对象] 
             */
            $scope.selectDoc = function(item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
                cancelBatchOperate();
            };
            /**
             * [cancelBatchOperate description：取消批量操作的样式]
             */
            function cancelBatchOperate() {
                if ($scope.data.selectedArray.length === 0) {
                    $scope.status.batchOperateBtn = {
                        "hoverStatus": "",
                        "clickStatus": ""
                    };
                }
            }

            /**
             * [addConfig description]添加个人中心配置
             */
            $scope.addConfig = function() {
                personalCenterConfigService.addOrEditPersonalCenterConfig("").then(function(data) {
                    requestData();
                }, function(data) {
                    //失败
                });
            };
            /**
             * [editConfig description]修改个人中心配置
             */
            $scope.editConfig = function(item) {
                personalCenterConfigService.addOrEditPersonalCenterConfig(item).then(function(data) {
                    requestData();
                }, function(data) {
                    //失败
                });
            };
            /**
             * [setVisible description]设置可见不可见
             */
            $scope.setVisible = function(flag) {
                var flagWord = flag == 1 ? '可见' : '不可见';
                modalDialog.confirmModal("设置" + flagWord, "是否确认将选中的设置为" + flagWord, function() {
                    var params = {
                        serviceid: "mlf_personalcenter",
                        methodname: "setVisible",
                        ObjectIds: trsspliceString.spliceString($scope.data.selectedArray, 'PERSONALCENTERMODULEID', ","),
                        VISIBLE: flag
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                        modalDialog.alertType("设置" + flagWord + "成功", "", "success", false, function() {
                            requestData();
                        });
                    });
                });
            };
            /**
             * [delete description]删除
             * @return {[type]} [description]
             */
            $scope.delete = function() {
                modalDialog.confirmModal("删除模块", "是否确认将选中的模块删除", function() {
                    var params = {
                        serviceid: "mlf_personalcenter",
                        methodname: "deleteModules",
                        ObjectIds: trsspliceString.spliceString($scope.data.selectedArray, 'PERSONALCENTERMODULEID', ",")
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                        modalDialog.alertType("删除成功", "", "success", false, function() {
                            requestData();
                        });

                    });
                });

            };

        }
    ]);
